/* Small read button overlay for article feed item thumbnails.
   Navigates to the in-app article reader on click. */

import { BookOpen } from "lucide-react";
import { useNavigate } from "react-router-dom";

interface ArticleReadButtonProps {
  feedItemId: string;
}

export function ArticleReadButton({ feedItemId }: ArticleReadButtonProps) {
  const navigate = useNavigate();

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();
    navigate(`/article/${feedItemId}`);
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      onMouseDown={(e) => e.stopPropagation()}
      className="absolute inset-0 flex items-center justify-center bg-black/40 rounded-sm opacity-0 group-hover:opacity-100 hover:opacity-100 transition-opacity"
    >
      <div className="size-10 rounded-full bg-primary/90 flex items-center justify-center shadow-md">
        <BookOpen className="size-5 text-primary-foreground" />
      </div>
    </button>
  );
}
